export class BoardModel {
cmbBoard: string;
setValue(res){
if(res){
if(res['cmbBoard']){this.cmbBoard = res['cmbBoard'];}
}
}
}